import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SafeResourceUrl } from '@angular/platform-browser';
@Injectable({
  providedIn: "root"
})
export class CommondataService {

  private localStorageKey = 'provider';
  private valueSubject = new BehaviorSubject<string>('');

  private isLoadingSubject = new BehaviorSubject<boolean>(false)
  public isLoading$ = this.isLoadingSubject.asObservable();


  live = new Subject<string>();
  liveonclosed = new Subject<any>();
  playerLogPop = new Subject<any>();
  vpnProcessPopup = new Subject<any>();
  matchData = new Subject<any>();
  oddtypedata = new Subject<any>();
  odd = new Subject<string>();
  isLoggedI = new Subject<boolean>();
  couponresdata = new Subject<any>();
  sportslistdata = new Subject<any>();
  predata = new Subject<any>();
  pretypedata = new Subject<any>();
  topdata = new Subject<any>();
  betArrayOdd = new Subject<any>();
  getArrayOdd = new Subject<any>();
  private gameUrlSource = new BehaviorSubject<string | null>(null);
  gameUrl$ = this.gameUrlSource.asObservable();
  private history: string[] = [];
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects);
      });
  }


  private urlSafeSubject = new BehaviorSubject<SafeResourceUrl | null>(null);
  urlSafe$ = this.urlSafeSubject.asObservable();

  open(url: SafeResourceUrl) {
    this.urlSafeSubject.next(url);
  }

  close() {
    console.log(123465)
    this.urlSafeSubject.next(null);
  }
  getPreviousUrl(): string | null {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2];
    }
    return null;
  }
  private _showProviderGames = new BehaviorSubject<boolean>(true);
  showProviderGames$ = this._showProviderGames.asObservable();

  show() {
    this._showProviderGames.next(true);
  }

  hide() {
    this._showProviderGames.next(false);
  }

  showLoader() {
    this.isLoadingSubject.next(true)
  }

  hideLoader() {
    this.isLoadingSubject.next(false)
  }
  setGameUrl(url: string) {
    sessionStorage.setItem('gameUrl', url);
    this.gameUrlSource.next(url);
  }
  CountryMatches(data: any) {
    this.matchData.next(data);
  }
  getSportMatchData() {
    return this.matchData.asObservable();
  }
  homeOdd = new Subject<any>();

  getHomeOdd(bet: any) {
    this.homeOdd.next(bet);
  }
  OddTypeChange(oddtype: any) {
    this.oddtypedata.next(oddtype)
  }
  get Isselectedoddtype() {
    return this.oddtypedata.asObservable();
  }
  setLive(event: any) {
    this.live.next(event);
  }
  //     openPop() {
  //       this.vpnProcessPopup.next(data:any);
  //   }
  //   get openPopOpen$() { 
  //     return this.vpnProcessPopup.asObservable();
  // }

  OddData(bet: any) {
    this.odd.next(bet);
  }
  betArrayfind(betarray: any) {
    this.betArrayOdd.next(betarray);
  }
  getbetArrayfind(value: any) {
    this.getArrayOdd.next(value);
  }
  private searchTermSource = new BehaviorSubject<string>('');
  searchTerm$ = this.searchTermSource.asObservable();

  setSearchTerm(term: string) {
    this.searchTermSource.next(term);
  }

  couponData(data: any) {
    this.couponresdata.next(data);
  }
  setIsLoogedIn(loggedIn: boolean) {
    this.isLoggedI.next(loggedIn);
  }
  get isLoogedIn$() {
    return this.isLoggedI.asObservable();
  }
  sportslist(sportsdata: any) {
    this.sportslistdata.next(sportsdata);
  }
  get sportslist$() {
    return this.sportslistdata.asObservable();
  }
  prematchdata(data: any) {
    this.predata.next(data);
  }
  get data$() {
    return this.predata.asObservable();
  }
  prematchtype(data: any) {
    this.pretypedata.next(data);
  }
  get pretypedata$() {
    return this.pretypedata.asObservable();
  }
  toptenleagues(data: any) {

    this.topdata.next(data);
  }
  get topdata$() {
    return this.topdata.asObservable();
  }

  getValue(): string {
    return '';
  }
  setValue(value: string): void {
    this.valueSubject.next(value);
  }

  getValueObservable() {
    return this.valueSubject.asObservable();
  }
  
  private popupState = new BehaviorSubject<{ isOpen: boolean; type: string | null }>({ isOpen: false, type: null });
  popupState$ = this.popupState.asObservable();

  openModal(type: string) {
    this.popupState.next({ isOpen: true, type });
  }

  closePopup() {
    this.popupState.next({ isOpen: false, type: null });
  }
}